import React, { Component } from 'react';
import { List, Update, Get, Create, Delete, ListEvents } from './graphql.js';
import Workshops from '../../components/Workshops';
import {
  gqlOperation,
  saveHandler,
  deleteHandler,
  logError,
  parseAwsJson,
  parseAwsJsonInArr,
  updateInPath
} from '../../../../common/utils';
import { clone } from 'ramda';


export default class WorkshopsContainer extends Component {
  constructor() {
    super();

    this.state = { data: [], events: [] };
  }
  
  fetchData = () => {
    gqlOperation(List, {})
      .then(({ listMyWorkshops: w }) => {
        this.setState(s => updateInPath(s, 'data', parseAwsJsonInArr(w.items, ['userData'])));
      })
      .catch(logError);

    gqlOperation(ListEvents, {})
      .then(({ listEvents: e }) => {
        this.setState(s => updateInPath(s, 'events', e));
      })
      .catch(logError);
  }

  handleWorkshopSave = (formData) => {
    const data = clone(formData);

    // TODO: see utils->toAwsJson text
    data.userData = JSON.stringify(data.userData);
    delete data.userId;

    saveHandler(
      data,
      [
        { from: 'competition', to: 'competitionId' },
        { from: 'event', to: 'eventId' }
      ],
      data.workshopId ? Update : Create,
      () => {  this.fetchData(); }
    );
  }

  handleWorkshopDelete = (workshopId) => {
    deleteHandler({ workshopId: workshopId }, [], Delete, () => {  this.fetchData(); });
  }

  handleWorkshopGet = (workshopId, userId, callback) => {
    gqlOperation(Get, { workshopId: workshopId, userId: userId })
      .then(({ getMyWorkshop: w }) =>
            callback(parseAwsJson(w, ['userData'])))
      .catch(logError);
  };
  
  componentDidMount() {
    this.fetchData();
  }

  render() {
    const { data, events } = this.state;

    return (
      <Workshops
        data={data}
        events={events}
        refresh={this.fetchData}
        onWorkshopDelete={this.handleWorkshopDelete}
        onWorkshopView={this.handleWorkshopGet}
        onWorkshopSave={this.handleWorkshopSave} />
    );
  }
}




// WEBPACK FOOTER //
// ./src/private/user/containers/Workshops/index.js